import { PaperOption } from "common/constants"

export const translateMapFactory = (t: any) => (options: PaperOption[]) =>
  options.map((o) => ({ ...o, label: t(`pdf.${o.label}`) }))

export const translateLabelFactory = (t: any) => (label: string) =>
  t(`pdf.${label}`)
